/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*
 * @Description:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-10 09:32:44
 * @LastEditors: sj
 * @LastEditTime: 2022-08-22 16:56:54
 */
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  SearchOutlined,
  SettingFilled,
  SettingOutlined,
} from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  message as messageShow,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Switch,
} from 'antd'
import styles from './outRecipe.module.css'
import {
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import { EditableList } from '../../compnents/list/EditableList'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { Columns } from './columns'
import moment from 'moment'
import { selectInsuranceItem, setInsurance } from '../../layouts/insuranceSlice'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import { User } from '../../models/user'
import { getDoctorList } from '../sales/DoctorAccont/doctorAuditSlice'
import { ColumnsForWaitUpload } from './columnsForWaitUpload'
import {
  outRecipeAsync,
  outRecipeSimpleAsync,
} from '../payment/confirm/paymentConfirmSlice'
import { medicalSendHttp, strParse } from '../../utils/MedicalUtils'
import { getTreatment } from '../treatment/diagnosis/diagnosisSlice'
import { outRecipeListWaitUploadAsync } from './outRecipeSlice'
import { GlobalKeyboardAction } from '../../compnents/actions/GlobalKeyboardAction'
import { RecipeCategory } from '../../models/recipe'
import { Settings } from '../../models/setting'
import { setSettings } from '../settings/settingsSlice'
import { getSaveSomeFunctions } from '../registration/register/registerSlice'
import {
  getRecipeAdapterMsgAsync,
  updateTreatmentTypeAsync,
} from '../retail/retailSlice'
import { traceRoute } from '../../layouts/layoutSlice'

function OutRecipeWaitUpload() {
  const dispatch = useDispatch<RootDispatch>()

  // form 表单初始化
  const [form] = Form.useForm()

  const [repealForm] = Form.useForm()

  const [head, tail] = getDateRange(DateRangeType.Today)
  // 表格参数
  const [queries, setQueries] = useState({
    current: 0,
    size: 20,
    registrationTimeHead: head,
    registrationTimeTail: tail,
  })
  const [data, setData] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [visible, setVisible] = useState(false)

  const [message, setMessage] = useState('')

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantName = useSelector(selectTenantName)

  const tenantCategory = useSelector(selectTenantCategory)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const insuranceArray = useSelector(selectInsuranceArray)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const baseData = useSelector(selectInsuranceItem)

  const [action, setAction] = useState('')

  const [doctors, setDoctors] = useState<User[]>([])

  const [loading, setLoading] = useState(false)

  const [treatmentId, setTreatmentId] = useState(0)
  const [autoFlag, setAutoFlag] = useState(false)
  const [settingShowFlag, setSettingShowFlag] = useState(false)

  const success = (str: string) => {
    messageShow.loading(str, 3)
  }

  // 7101
  const outRecipe = (
    serverType: any,
    outRecipeParams?: any,
    responseString?: string
  ) => {
    dispatch(
      outRecipeSimpleAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem?.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          ...outRecipeParams,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          success('正在上传外配处方')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                notification.error({
                  message: '外配处方上传失败，已打回',
                })
                const mg = call?.netmessage?.err_msg
                dispatch(
                  updateTreatmentTypeAsync({
                    treatmentId: Number(outRecipeParams?.treatmentId),
                    treatmentType: 3,
                    reason: mg,
                  })
                )
                  .then(unwrapResult)
                  .then((v) => {
                    getTable(() => {
                      console.log('search success')
                    })
                  })

                // setOutRepiceLoading(false)
              } else {
                outRecipe(
                  'response',
                  outRecipeParams,
                  JSON.stringify(call.netmessage)
                )
              }
            },
            undefined
          )
        } else {
          // messageNotification('结算成功')
          notification.success({
            message: '外配处方上传成功。',
          })
          // outRecipeRef.current.reset()
          // setOutRecipeVisible(false)
          // setOutRepiceLoading(false)
          // setOutRecipeDisable(true)
          getTable(() => {
            console.log('search success')
          })
        }
      })
      .catch((v) => {
        notification.error({
          message: '外配处方上传失败，已打回：' + v.message,
        })
        const mg = v.message
        dispatch(
          updateTreatmentTypeAsync({
            treatmentId: Number(outRecipeParams?.treatmentId),
            treatmentType: 3,
            reason: mg,
          })
        )
          .then(unwrapResult)
          .then((v) => {
            getTable(() => {
              console.log('search success')
            })
          })
        // setOutRepiceLoading(false)
      })
  }

  useEffect(() => {
    dispatch(getDoctorList())
      .then(unwrapResult)
      .then((doctors) => setDoctors(doctors))
  }, [])

  const autoUpload = () => {
    getTable((dataRecord) => {
      // timer = setInterval(() => {
      for (let i = 0; i < dataRecord.length; i++) {
        if (dataRecord?.[i]?.id) {
          try {
            outRecipe('requestString', {
              treatmentId: Number(dataRecord?.[i]?.id),
            })
          } catch (e) {
            notification.success({
              message: '外配处方上传失败：' + e.message,
            })
          } finally {
            if (i == dataRecord.length - 1) {
              notification.success({
                message: '本轮上传完毕',
              })
            }
          }
        }
      }
      // }, 5000)
    }, true)
  }

  //监听开关
  useEffect(() => {
    if (autoFlag) {
      //先执行一次
      autoUpload()

      const timer = setInterval(() => {
        autoUpload()
      }, 60000)

      // 返回清理函数
      return () => {
        clearInterval(timer)
      }
    }
  }, [autoFlag])

  useEffect(() => {
    if (insuranceArray.length !== 0) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  // 保存医保结构体
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
    return () => {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  useEffect(() => {
    form.setFieldsValue({
      registrationTimeHead: head,
      registrationTimeTail: tail,
    })
    form.submit()
  }, [])

  useEffect(() => {
    if (!queries.current) return
    getTable(() => {
      console.log('search success')
    })
  }, [queries])

  // 获取表格数据
  const getTable = (callback: (data: any) => void, flag?: any) => {
    // flag 自动上传查询标志
    setPageLoading(true)
    dispatch(
      outRecipeListWaitUploadAsync({
        ...queries,
        registrationTimeHead: flag
          ? head
          : queries?.registrationTimeHead
          ? queries?.registrationTimeHead
          : head,
        registrationTimeTail: flag
          ? moment().add(3, 'day').endOf('day').format(DateTimeFormat)
          : queries?.registrationTimeTail
          ? queries?.registrationTimeTail
          : tail,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res)
        if (callback) {
          callback(res.records)
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  const filter = (
    <Row>
      <Col
        style={{
          padding: '10px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
        }}
      >
        <Form.Item label='自动上传'>
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setAutoFlag(v)
              if (v) {
                form.resetFields()
                form.setFieldsValue({
                  registrationTimeHead: head,
                  registrationTimeTail: moment()
                    .add(3, 'day')
                    .endOf('day')
                    .format(DateTimeFormat),
                })
                form.submit()
              }
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  )

  return (
    <div className={styles.wrap}>
      <Form
        form={form}
        onFinish={(values: any) => {
          if(!values?.registrationTimeHead){
            return
          }
          setQueries({ ...queries, ...values, current: 1 })
        }}
      >
        <Row gutter={11} style={{ height: '42px' }}>
          <Col span={4}>
            <Form.Item name='param'>
              <Input
                size='middle'
                placeholder='搜索患者姓名'
                allowClear
                prefix={<SearchOutlined />}
                onChange={form.submit}
              />
            </Form.Item>
          </Col>
          <Col>
            <DateSelect
              disabledValue={autoFlag}
              placeholder='请选择时间'
              labelPrefix=''
              namePrefix='registrationTime'
              initialValue={DateRangeType.Today}
              allowClear={false}
              style={{ width: '8.5rem' }}
              onChange={form.submit}
            />
          </Col>
          <Col>
            <Button htmlType='submit' type='primary' style={{ float: 'right' }} loading={pageLoading}>
              查询
            </Button>
          </Col>

          {/*<div*/}
          {/*  style={{*/}
          {/*    position:"absolute",*/}
          {/*    right:"45px",*/}
          {/*    display: 'flex',*/}
          {/*    alignItems: 'center',*/}
          {/*    color: '#027AFF',*/}
          {/*  }}*/}
          {/*  onClick={() => {*/}
          {/*    console.log(1)*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Dropdown*/}
          {/*    trigger={['click']}*/}
          {/*    overlay={filter}>*/}
          {/*  </Dropdown>*/}

          {/*</div>*/}
          <Dropdown
            trigger={['click']}
            overlay={filter}
            visible={settingShowFlag}
            onVisibleChange={(v) => {
              setSettingShowFlag(v)
            }}
          >
            <SettingFilled
              style={{
                position: 'absolute',
                right: '30px',
                fontSize: '18px',
                color: autoFlag ? '#027AFF' : '#333',
              }}
              onClick={() => setSettingShowFlag(!settingShowFlag)}
            />
          </Dropdown>
        </Row>
      </Form>
      <EditableList
        loading={pageLoading}
        columns={ColumnsForWaitUpload((id, action, t) => {
          if (action == 'uploadOne') {
            outRecipe('requestString', {
              treatmentId: Number(t?.id),
            })
          } else if (action == 'audit') {
            if (t?.registrationId) {
              dispatch(
                traceRoute({
                  name: '外配处方',
                  path: '/treatment',
                  query: `registrationId=${t?.registrationId}&wpcfFlag=${true}`,
                  state: {
                    backSelectTab: 'editor',
                  },
                })
              )
            }
          }else if(action == 'reject'){
            notification.success({
              message: '已打回',
            })
            const mg = "医生审核不通过"
            dispatch(
              updateTreatmentTypeAsync({
                treatmentId: Number(Number(t?.id)),
                treatmentType: 3,
                reason: mg,
              })
            )
              .then(unwrapResult)
              .then((v) => {
                getTable(() => {
                  console.log('search success')
                })
              })
          }
        }, (queries.size || 20) * ((queries.current || 1) - 1))}
        onChangePage={(current, size) => {
          setQueries({
            ...queries,
            current,
            size: size || 20,
          })
        }}
        page={{
          size: queries.size || 20,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        rowKey={(_, i) => `${i}`}
      />
    </div>
  )
}

export default OutRecipeWaitUpload
